console.log('>> Common script is loaded.');
